export function getRandom() {
  return Math.random();
}

export function getRandomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getRandomIndex(array) {
	return getRandomInt(0, array.length - 1);
}

export const randomBool = (function () {
  const a = new Uint8Array(1)
  return function () {
    crypto.getRandomValues(a)
    return a[0] > 127
  }
})()
